import { Component, OnInit , Input , ElementRef , ViewChild,  OnChanges } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';


@Component({
  selector: 'app-urlhtml',
  templateUrl: './urlhtml.component.html',
  styleUrls: ['./urlhtml.component.scss'],
})
export class UrlhtmlComponent implements OnInit {

  @Input() url : string;
  
  @ViewChild('idcontent', {static: false}) idcontent : ElementRef;
  

  constructor(public gfichier : GfichierService) { }

  ngOnInit() {}

  ngOnChanges() {
    //let log: string[] = [];
    //alert(this.url);
    this.gfichier.loadFichier(this.url).then(
      successData => {
        
        this.idcontent.nativeElement.innerHTML = String(successData);
        //this.gfichier.setContent2(this.content);
        
      },
      rejectData => {
        console.log(rejectData);
      }
      );
    }

  
}
